export default __webpack_public_path__ + "static/baby-48305c945e725cffddcc37a2306a01ee.png";